export enum EmployeeTypeString {
	EXT = 'Intervenant(e) extérieur(e)',
	EMP = 'Employé(e)'
}

export enum EmployeeType {
	'EXT' = 'EXT',
	'EMP' = 'EMP'
}
